import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "type", "fullWidth", "autoplay", "hidePagination", "pagination", "outsideButtons", "lazyLoad", "lazyLoadOffset", "infiniteLoop", "onSlideIndexChanged", "shouldHandlePointerMove"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Carousel/Carousel.js",
  _this = this;
import React, { useState, useEffect, useImperativeHandle } from 'react';
import { ArrowLeft, ArrowRight } from '@dls/assets/icons';
import { Wrapper, CarouselWrapper, CarouselContainer, CarouselSlot, ArrowButton, OutsideArrowButtonWrapper, PaginationPanel, PaginationDot } from './style';
import { testIdProps } from '../../helpers';
import CarouselSwimlane from './CarouselSwimlane';
import CarouselContent from './CarouselContent';
var Carousel = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    type = _ref.type,
    fullWidth = _ref.fullWidth,
    autoplay = _ref.autoplay,
    hidePagination = _ref.hidePagination,
    pagination = _ref.pagination,
    outsideButtons = _ref.outsideButtons,
    lazyLoad = _ref.lazyLoad,
    lazyLoadOffset = _ref.lazyLoadOffset,
    _ref$infiniteLoop = _ref.infiniteLoop,
    infiniteLoop = _ref$infiniteLoop === void 0 ? true : _ref$infiniteLoop,
    _ref$onSlideIndexChan = _ref.onSlideIndexChanged,
    onSlideIndexChanged = _ref$onSlideIndexChan === void 0 ? function () {} : _ref$onSlideIndexChan,
    _ref$shouldHandlePoin = _ref.shouldHandlePointerMove,
    shouldHandlePointerMove = _ref$shouldHandlePoin === void 0 ? true : _ref$shouldHandlePoin,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (type === 'card') {
    return /*#__PURE__*/React.createElement(CarouselSwimlane, _extends({
      type: type
    }, rest, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 9
      }
    }), children);
  }
  useImperativeHandle(ref, function () {
    return {
      resetCarousel: resetCarousel
    };
  });
  var numOfPage = React.Children.count(children);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scrolledSlides = _useState4[0],
    setScrolledSlides = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    pointerPosition = _useState6[0],
    setPointerPosition = _useState6[1];
  var showLeftArrow = infiniteLoop || active > 0;
  var showRightArrow = infiniteLoop || active < numOfPage - 1;
  var resetCarousel = function resetCarousel() {
    moveToSlide(0);
  };
  var handlePointerDown = function handlePointerDown(e) {
    if (!shouldHandlePointerMove || numOfPage <= 1) return;
    var pointerDown = e.clientX;
    setPointerPosition(pointerDown);
  };
  var handlePointerMove = function handlePointerMove(e) {
    if (!shouldHandlePointerMove || numOfPage <= 1) return;
    var pointerDown = pointerPosition;
    if (pointerDown === null) {
      return;
    }
    var currentPointer = e.clientX;
    var diff = pointerDown - currentPointer;
    if (diff > 0.1) {
      moveToSlide(active + 1);
    }
    if (diff < -0.1) {
      moveToSlide(active - 1);
    }
    setPointerPosition(null);
  };
  useEffect(function () {
    if (autoplay) {
      var interval = setInterval(function () {
        moveToSlide(active + 1);
      }, autoplay * 1000);
      return function () {
        return clearInterval(interval);
      };
    }
  }, [active]);
  useEffect(function () {
    if (active > scrolledSlides) {
      setScrolledSlides(active);
    }
  }, [active]);
  var moveToSlide = function moveToSlide(index) {
    var slideIndex = index;
    if (index > numOfPage - 1) slideIndex = 0;
    if (index < 0) slideIndex = numOfPage - 1;
    setActive(slideIndex);
    onSlideIndexChanged(index);
  };
  var renderChildren = function renderChildren(pagination, type) {
    var carouselChildren = React.Children.toArray(children);
    var renderedChildren;
    if (carouselChildren.length) {
      if (type === 'image' && lazyLoad) {
        var visibleItemsCount = scrolledSlides + lazyLoadOffset + 1;
        var notVisibleItemsCount = carouselChildren.length - visibleItemsCount;
        var visibleComponents = carouselChildren.slice(0, visibleItemsCount);
        var virtualizedItems = Array(notVisibleItemsCount > 0 ? notVisibleItemsCount : 0).fill(null);
        if (notVisibleItemsCount > 0) {
          renderedChildren = visibleComponents.concat(virtualizedItems);
        } else {
          renderedChildren = visibleComponents;
        }
      } else {
        renderedChildren = carouselChildren;
      }
      return renderedChildren.map(function (child, index) {
        return /*#__PURE__*/React.createElement(CarouselSlot, {
          key: index,
          pagination: pagination,
          type: type,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 132,
            columnNumber: 11
          }
        }, child);
      });
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Wrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 9
    }
  }, !outsideButtons && numOfPage > 1 && /*#__PURE__*/React.createElement(ArrowButton, {
    "data-testid": "arrow-left",
    onClick: function onClick() {
      return moveToSlide(active - 1);
    },
    left: true,
    inside: true,
    showArrow: showLeftArrow,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    size: 25,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 15
    }
  })), outsideButtons && numOfPage > 1 && /*#__PURE__*/React.createElement(OutsideArrowButtonWrapper, {
    left: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(ArrowButton, {
    "data-testid": "outside-arrow-left",
    onClick: function onClick() {
      return moveToSlide(active - 1);
    },
    left: true,
    showArrow: showLeftArrow,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    size: 25,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(CarouselWrapper, {
    fullWidth: fullWidth,
    type: type,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 168,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(CarouselContainer, {
    "data-testid": "carousel-container",
    current: active,
    onPointerDown: handlePointerDown,
    onPointerMove: handlePointerMove,
    type: type,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 13
    }
  }, renderChildren(pagination, type))), !outsideButtons && numOfPage > 1 && /*#__PURE__*/React.createElement(ArrowButton, {
    "data-testid": "arrow-right",
    onClick: function onClick() {
      return moveToSlide(active + 1);
    },
    right: true,
    inside: true,
    showArrow: showRightArrow,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 181,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    size: 25,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 15
    }
  })), outsideButtons && numOfPage > 1 && /*#__PURE__*/React.createElement(OutsideArrowButtonWrapper, {
    right: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(ArrowButton, {
    "data-testid": "outside-arrow-right",
    onClick: function onClick() {
      return moveToSlide(active + 1);
    },
    right: true,
    showArrow: showRightArrow,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 194,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    size: 25,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 17
    }
  })))), !hidePagination && /*#__PURE__*/React.createElement(PaginationPanel, {
    type: type,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 11
    }
  }, numOfPage > 1 && _toConsumableArray(Array(numOfPage).keys()).map(function (page) {
    return /*#__PURE__*/React.createElement(PaginationDot, {
      "data-testid": "Pagination".concat(page + 1),
      key: page,
      active: page === active,
      onClick: function onClick() {
        return moveToSlide(page);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 210,
        columnNumber: 17
      }
    });
  })));
});
Carousel.defaultProps = {
  autoplay: 0,
  fullWidth: false,
  hidePagination: false,
  outsideButtons: false,
  pagination: 1,
  lazyLoad: false,
  lazyLoadOffset: 1
};
Carousel.displayName = 'Carousel';
Carousel.CarouselContent = CarouselContent;
export default Carousel;